import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { LE_BUSINESS_TRAVELLER } from '~/consts/businessTraveller';

import { GetNotificationsProps, getNotifications } from '~/services/SailthruService';

const ACTIVATION_NOTIFICATION_TYPE = 'business_employee_invited';

type ActivationEmailFilters = Omit<GetNotificationsProps, 'notificationType' | 'brand'>;

export const activationEmailsQueryKeys = {
  all: ['lebt-activation-emails'] as const,
  list: (filters: ActivationEmailFilters) => [...activationEmailsQueryKeys.all, 'list', filters] as const,
};

export function useGetActivationEmails(filters: ActivationEmailFilters) {
  return useQuery({
    queryKey: activationEmailsQueryKeys.list(filters),
    queryFn: ({ signal }) =>
      getNotifications(
        { ...filters, notificationType: ACTIVATION_NOTIFICATION_TYPE, brand: LE_BUSINESS_TRAVELLER },
        signal,
      ),
    placeholderData: keepPreviousData,
  });
}
